import { render } from "./Campaign.vue?vue&type=template&id=34536885&scoped=true&ts=true"
import script from "./Campaign.vue?vue&type=script&lang=ts"
export * from "./Campaign.vue?vue&type=script&lang=ts"

import "./Campaign.vue?vue&type=style&index=0&id=34536885&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34536885"]])

export default __exports__